<!-- TODO: For now work only with boolean feature values -->
<ng-container *ngIf="launcherFeatures && launcherFeatures.length">
  <div *ngFor="let launcherFeature of launcherFeatures">
    <mat-checkbox
      [disableRipple]="true"
      [checked]="launcherFeature.FeatureValue === appConst.LAUNCHER_FEATURE_ENABLED"
      (change)="launcherFeature.FeatureValue = $event.checked ? appConst.LAUNCHER_FEATURE_ENABLED : appConst.LAUNCHER_FEATURE_DISABLED"
      [matTooltip]="getFeatureTooltip(launcherFeature)"
      class="light">
      {{getFeatureName(launcherFeature)}}
    </mat-checkbox>
  </div>
</ng-container>
